import { expect } from '@playwright/test';
import { test } from '@stencil/playwright';

test.describe('Nylas Calendar Picker', () => {
  test('should render and be hydrated', async ({ page }) => {
    await page.setContent('<nylas-calendar-picker></nylas-calendar-picker>');

    const component = page.locator('nylas-calendar-picker');
    expect(component).toBeDefined();
    await expect(component).toHaveClass('hydrated');
  });

  test('should reflect the name property as an attribute', async ({ page }) => {
    await page.setContent('<nylas-calendar-picker name="my-calendar"></nylas-calendar-picker>');

    const component = page.locator('nylas-calendar-picker');
    await expect(component).toHaveAttribute('name', 'my-calendar');
  });
});
